import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase.js';
import { titusDayNumber } from '../../lib/dates.js';

// Standalone Titus Ten principle card. Used both inside StepGreeting (in a
// WizardCard wrapper) and as a persistent post-briefing card.
//
// Props:
//   variant: 'standalone' (default) renders its own bg-card chrome.
//            'embed' renders bare content (used inside another card).
export default function TitusPrincipleCard({ variant = 'standalone' }) {
  const [principle, setPrinciple] = useState(null);

  useEffect(() => {
    const dayNum = titusDayNumber();
    supabase
      .from('titus_ten')
      .select('day_number, principle, summary, key_verse, action_prompt')
      .eq('day_number', dayNum)
      .maybeSingle()
      .then(({ data }) => setPrinciple(data));
  }, []);

  const body = principle ? (
    <div>
      <div className="text-xs uppercase tracking-wider text-text-secondary mb-2">
        Today's principle · Day {principle.day_number} of 10
      </div>
      <div className="text-base font-semibold text-accent-purple mb-2">
        {principle.principle}
      </div>
      <p className="text-sm text-text-primary leading-relaxed">
        {principle.summary}
      </p>
      {principle.key_verse && (
        <blockquote className="mt-3 text-xs text-text-secondary italic border-l-2 border-border-base pl-3">
          {principle.key_verse}
        </blockquote>
      )}
      {principle.action_prompt && (
        <div className="mt-3 text-xs text-text-secondary">
          <span className="uppercase tracking-wide text-text-muted">
            Action ·{' '}
          </span>
          {principle.action_prompt}
        </div>
      )}
    </div>
  ) : (
    <div className="text-sm text-text-muted">Loading…</div>
  );

  if (variant === 'embed') return body;

  return (
    <div className="max-w-md mx-auto mt-4 bg-bg-card border border-border-base rounded p-5">
      {body}
    </div>
  );
}
